<template>
  <div>
    <nav
      class="navbar navbar-expand-lg navbar-light bg-light fixed-top p-st"
      :class="{
        'bg-light': !nightMode,
        'navbar-blur': navbarConfig.blur,
        'bg-dark2': nightMode,
      }"
    >
      <div class="container">
        <a
          class="navbar-brand"
          href="/"
          @click.prevent="$emit('scroll', 'home')"
        >
          <Logo :nightMode="nightMode" />
        </a>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span style="color: gray; font-size: 23px;"
            ><i class="fas fa-bars"></i>
            </span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav ml-auto">
            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/about"
                @click.prevent="$emit('scroll', 'about')"
                :class="{ 'text-light': nightMode }"
                >About</a
              >
            </li>
            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/skills"
                @click.prevent="$emit('scroll', 'skills')"
                :class="{ 'text-light': nightMode }"
                >Skills</a
              >
            </li>
            <li class="nav-item mx-2 ">
              <a
                class="nav-link"
                href="/portfolio"
                @click.prevent="$emit('scroll', 'portfolio')"
                :class="{ 'text-light': nightMode }"
                >Portfolio</a
              >
            </li>
            <li class="nav-item mx-2">
              <a
                class="nav-link"
                href="/contact"
                @click.prevent="$emit('scroll', 'contact')"
                :class="{ 'text-light': nightMode }"
                >Contact</a
              >
            </li>
            <li class="nav-item ml-2">
              <a
                class="nav-link"
                href="#"
                @click.prevent="switchMode"
                :class="{ 'text-light': nightMode }"
                ><i
                  :class="{
                    'fas fa-sun': nightMode,
                    'far fa-sun': !nightMode,
                  }"
                  v-tooltip.bottom="nightMode ? 'Light Mode' : 'Night Mode'"
                ></i
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import Logo from "./helpers/Logo";
import info from "../../info";

export default {
  name: "Navbar",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      navbarConfig: info.config.navbar,
      localNightMode: this.nightMode,
    };
  },
  components: {
    Logo,
  },
  methods: {
    switchMode() {
      this.localNightMode = !this.localNightMode;
      this.$emit("nightMode", this.localNightMode);
    },
  },
};
</script>

<style scoped>
.nav-link {
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}
.nav-link:hover{
  background-color: rgba(160, 159, 159, 0.336);
  transform: translateY(-2px);
}

button {
  border: none;
  outline: none;
  padding: 8px 12px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

button:hover {
  border: none;
  outline: none;
  background-color: rgba(160, 159, 159, 0.1);
}

button:focus {
  outline: none;
  box-shadow: none;
}

nav {
  border-bottom: 1px solid rgba(160, 159, 159, 0.336);
  position: fixed !important;
  z-index: 1000;
}

.navbar-blur {
  background-color: #ffffff7e;
  backdrop-filter: blur(12px);
}

/* Mobile responsive navbar */
@media only screen and (max-width: 768px) {
  .nav-link {
    padding: 12px 16px;
    margin: 4px 0;
    font-size: 16px;
    text-align: center;
  }

  .navbar-nav {
    text-align: center;
    padding: 1rem 0;
  }

  .navbar-collapse {
    background-color: inherit;
    padding: 1rem 0;
    border-radius: 8px;
    margin-top: 10px;
  }

  button {
    padding: 10px 14px;
  }

  .fa-bars {
    font-size: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .nav-link {
    padding: 14px 16px;
    font-size: 15px;
  }

  .navbar-nav {
    padding: 0.5rem 0;
  }

  .navbar-collapse {
    margin-top: 5px;
  }

  button {
    padding: 12px 16px;
  }

  .fa-bars {
    font-size: 18px;
  }
}

/* Improved mobile menu toggle */
.navbar-toggler {
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  background-color: transparent;
  transition: all 0.3s ease;
}

.navbar-toggler:hover {
  background-color: rgba(160, 159, 159, 0.1);
}

.navbar-toggler:focus {
  outline: none;
  box-shadow: none;
}
</style>
